/* DeD Biancheria — Theme JS */

// Header scroll effect
(function () {
  const header = document.querySelector('.site-header');
  if (!header) return;
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 40);
  }, { passive: true });
})();

// Mobile menu
(function () {
  const btn = document.querySelector('.mobile-menu-btn');
  const nav = document.querySelector('.mobile-nav');
  const close = document.querySelector('.mobile-nav-close');
  if (!btn || !nav) return;
  btn.addEventListener('click', () => nav.classList.add('open'));
  if (close) close.addEventListener('click', () => nav.classList.remove('open'));
})();

// Mobile submenu toggles
document.querySelectorAll('.mobile-nav-parent').forEach(function (btn) {
  btn.addEventListener('click', function () {
    const item = btn.closest('.mobile-nav-item');
    const isOpen = item.classList.contains('open');

    // Close all open items first
    document.querySelectorAll('.mobile-nav-item.open').forEach(function (el) {
      el.classList.remove('open');
    });

    // Open this one if it wasn't already open
    if (!isOpen) item.classList.add('open');
  });
});


// Cart drawer
(function () {
  const cartBtns = document.querySelectorAll('[data-cart-toggle]');
  const overlay = document.querySelector('.cart-overlay');
  const drawer = document.querySelector('.cart-drawer');
  const closeBtn = document.querySelector('.cart-close');

  function openCart() {
    overlay && overlay.classList.add('open');
    drawer && drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    overlay && overlay.classList.remove('open');
    drawer && drawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartBtns.forEach(btn => btn.addEventListener('click', openCart));
  overlay && overlay.addEventListener('click', closeCart);
  closeBtn && closeBtn.addEventListener('click', closeCart);
})();

// Quantity selectors
document.querySelectorAll('.qty-selector').forEach(sel => {
  const input = sel.querySelector('.qty-input');
  sel.querySelector('.qty-minus')?.addEventListener('click', () => {
    const v = parseInt(input.value) || 1;
    if (v > 1) input.value = v - 1;
  });
  sel.querySelector('.qty-plus')?.addEventListener('click', () => {
    input.value = (parseInt(input.value) || 1) + 1;
  });
});

// Smooth reveal on scroll
(function () {
  const elements = document.querySelectorAll('.reveal');
  if (!elements.length) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  elements.forEach(el => observer.observe(el));
})();

// Product gallery thumbnails
(function () {
  const thumbs = document.querySelectorAll('.product-gallery-thumb');
  const main = document.querySelector('.product-gallery-main img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      if (main) main.src = thumb.dataset.full;
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });
})();

// Format money helper (cents to €)
function formatMoney(cents) {
  return (cents / 100).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
}

// Re-render cart drawer from live cart data
function refreshCart() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      // Update badge
      const cartBtn = document.querySelector('[data-cart-toggle]');
      let badge = document.querySelector('.cart-count');
      if (cart.item_count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'cart-count';
          cartBtn && cartBtn.appendChild(badge);
        }
        badge.textContent = cart.item_count;
      } else {
        badge && badge.remove();
      }

      // Update drawer items
      const itemsEl = document.querySelector('.cart-items');
      const footerEl = document.querySelector('.cart-footer');
      if (!itemsEl) return;

      if (cart.item_count === 0) {
        itemsEl.innerHTML = `
          <div style="text-align:center; padding:3rem 1rem; color:var(--color-text-light);">
            <p style="font-family:var(--font-heading); font-size:1.1rem; font-style:italic;">Il carrello è vuoto</p>
            <p style="font-size:0.82rem; margin-top:0.5rem;">Scopri i nostri prodotti e inizia ad acquistare</p>
            <a href="/collections" style="margin-top:1.5rem; display:inline-block; background:#8B1A2F; color:#fff; padding:14px 32px; text-decoration:none; letter-spacing:0.08em; font-size:0.85rem; text-transform:uppercase;">Scopri i prodotti</a>

          </div>`;
        footerEl && footerEl.remove();
      } else {
        itemsEl.innerHTML = cart.items.map(item => `
          <div class="cart-item" data-key="${item.key}">
            <img class="cart-item-image" src="${item.image}" alt="${item.title}" style="width:60px;height:60px;object-fit:cover;">
            <div style="flex:1;">
              <div class="cart-item-name">${item.product_title}</div>
              ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item-variant">${item.variant_title}</div>` : ''}
              <div class="cart-item-price">${formatMoney(item.final_price)}</div>
            </div>
            <button class="cart-item-remove" data-key="${item.key}" aria-label="Rimuovi">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>
        `).join('');

        // Update or create footer
        if (footerEl) {
          const subtotal = footerEl.querySelector('.cart-subtotal span:last-child');
          if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
        } else {
          const drawer = document.querySelector('.cart-drawer');
          const newFooter = document.createElement('div');
          newFooter.className = 'cart-footer';
          newFooter.innerHTML = `
            <div class="cart-subtotal">
              <span>Subtotale</span>
              <span>${formatMoney(cart.total_price)}</span>
            </div>
            <a href="/checkout" class="btn btn-primary btn-lg cart-checkout-btn full-width">Procedi all'Acquisto</a>
            <a href="/cart" style="display:block;text-align:center;margin-top:0.75rem;font-size:0.8rem;color:var(--color-text-light);">Visualizza carrello</a>`;
          drawer && drawer.appendChild(newFooter);
        }
      }
    });
}

// Make refreshCart globally available (used by inline script in header)
window.refreshCart = refreshCart;

// Product card: Add to Cart for single-variant products
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.product-card-add[data-variant-id]');
  if (!btn) return;
  e.preventDefault();

  const variantId = btn.dataset.variantId;
  const originalText = btn.textContent.trim();
  btn.disabled = true;
  btn.textContent = 'Aggiunta in corso...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(r => r.json())
    .then(data => {
      if (data.id) {
        btn.textContent = 'Aggiunto ✓';
        refreshCart();
      } else {
        btn.textContent = 'Errore';
      }
    })
    .catch(() => {
      btn.textContent = 'Errore';
    })
    .finally(() => {
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2000);
    });
});

// Ajax remove from cart drawer
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.cart-item-remove[data-key]');
  if (!btn) return;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
  })
    .then(r => r.json())
    .then(() => refreshCart());
});

document.querySelectorAll('.qty-input').forEach(input => {
  input.addEventListener('blur', function () {
    if (!this.value || parseInt(this.value) < 1) {
      this.value = 1;
    }
  });
    input.addEventListener('change', function () {
    if (!this.value || parseInt(this.value) < 1) {
      this.value = 1;
    }
  });

});
